<template>
  <div class="body flex-col">
    <div class="title">合约创建</div>
    <div class="text">预计合约地址</div>
    <div class="flex-row">
      <div class="address">{{ contractAddr }}</div>
      <div class="copyAddress">复制</div>
    </div>

    <div class="flex-col">
      <div class="text">开源参数</div>
      <div>
        <span class="parameter">Optimization: ves</span>
        <span class="parameter">Runs: 200</span>
      </div>
      <div>
        <div>
          <span class="parameter">Solidity Version: 0.8.18</span>
          <span class="parameter">License: MIT</span>
        </div>
      </div>
      <div style="margin-top: 30px">
        <span class="copy">复制源码</span>
        <span class="copy">复制构造参数</span>
      </div>
    </div>
    <div class="bottom">
      <div class="createBtn" v-if="finishDeployed">进入控制台</div>
      <div class="createBtn" v-else>创建合约</div>
    </div>
  </div>
</template>
<script>
import {deployContract,getPredictContractAddr} from "@/config/wallet.js";
import {} from "@/config/api.js";
export default {
  data() {
    return {
      finishDeployed: false,
      account: localStorage.getItem("TokenBox-account"),
      contractAddr: "",
      contractData: {},
    };
  },
  async beforeMount(){
     this.contractAddr = await getPredictContractAddr(this.account)
  },
  methods: {
    async submitForm(formName) {
      this.contractData.abi = JSON.parse(
        '[{"inputs":[{"internalType":"string","name":"_name1","type":"string"},{"internalType":"string","name":"_name2","type":"string"},{"internalType":"string","name":"_name3","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"getName1","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"greet","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"}]'
      );
      this.contractData.code =
        "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";
      var res2 = await deployContract(
        this.contractData.abi,
        this.contractData.code
      );
      console.log("res2=", res2);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>